enum Actions {
  // action types
  ADD_BODY_CLASSNAME = "addBodyClassName",
  REMOVE_BODY_CLASSNAME = "removeBodyClassName",
  ADD_BODY_ATTRIBUTE = "addBodyAttribute",
  REMOVE_BODY_ATTRIBUTE = "removeBodyAttribute",
  ADD_CLASSNAME = "addClassName",
  VERIFY_AUTH = "verifyAuth",
  LOGIN = "login",
  LOGOUT = "logout",
  REGISTER = "register",
  UPDATE_USER = "updateUser",
  UPDATE_PROFILE = "updateProfile",
  UPDATE_EMAIL = "updateEmail",
  UPDATE_PASSWORD = "updatePassword",
  FORGOT_PASSWORD = "forgotPassword",
  CONTACT = "contact",
  SET_BREADCRUMB_ACTION = "setBreadcrumbAction",
  GET_IRB_APPLICATION_LIST = "getIrbApplicationList",
  GET_IRB_SUSCRIBE_NOTIFICATION_ALERT = "getIrbSuscribeNotificationAlert",
  GET_IRB_NOTIFICATION_ALERT = "getIrbNotificationAlert",
  GET_IRB_NOTIFICATION_ALERT_PENDING = "getIrbNotificationAlertPending",
  GET_IRB_NOTIFICATION_ALERT_VISITED = "getIrbNotificationAlertVisited",
  GET_IRB_SUBMITTED_APPLICATION_LIST = "getSubmittedIrbApplicationList",
  GET_IRB_DASHBOARD_INFORMATION = "getDashBoardInformation",
  GET_IRB_COLLABORATIVE_APPLICATION_LIST = "getCollaborativeIrbApplicationList",
  GET_IRB_APPLICATION = "getIrbApplication",
  GET_IRB_APPLICATION_FACULTY = "getIrbApplicationFaculty",
  GET_IRB_APPLICATION_RESEARCH = "getIrbApplicationResearch",
  GET_IRB_APPLICATION_SUBJECT = "getIrbApplicationSubject",
  GET_IRB_APPLICATION_RISK = "getIrbApplicationRisk",
  GET_IRB_APPLICATION_RECRUITMENT = "getIrbApplicationRecruitment",
  GET_IRB_APPLICATION_INFORMED = "getIrbApplicationInformed",
  GET_IRB_APPLICATION_DATA = "getIrbApplicationData",
  GET_IRB_NONSTANDARD = "getIrbNonStandard",
  GET_IRB_TRANSACTION_LOG = "getIrbTransactionLog",
  GET_IRB_SCREENING = "getIrbScreening",
  GET_FACULTY_SPONSORS = "getFacultySponsors",
  GET_FACULTY_SPONSOR_REQUESTS = "getFacultySponsorRequests",
  GET_FACULTY_MEMBER = "getFacultyMember",
  GET_FACULTY_MEMBER_REQUESTS = "getFacultyMemberRequests",
  GET_IRB_APPLICATION_ISSUE = "getIrbApplicationIssue",
  GET_IRB_APPLICATION_ISSUES = "getIrbApplicationIssues",
  POST_IRB_SCREENING = "postIrbScreening",
  POST_IRB_ISSUE = "postIrbIssue",
  POST_IRB_ISSUE_UPDATE = "postIrbIssueUpdate",
  POST_IRB_APPLICATION = "postIrbApplication",
  POST_IRB_GPT = "postIrbGpt",
  POST_IRB_FACULTY = "postIrbFaculty",
  POST_IRB_FACULTY_SEND = "postIrbFacultySend",
  POST_IRB_NONSTANDARD = "postNonStandard",
  POST_IRB_RESEARCH = "postIrbResearch",
  POST_IRB_SUBJECT = "postIrbSubject",
  POST_IRB_RISK = "postIrbRisk",
  POST_IRB_RECRUITMENT = "postIrbRecruitment",
  POST_IRB_INFORMED = "postIrbInformed",
  POST_IRB_DATA = "postIrbData",
  POST_CO_INVESTIGATOR_FIND = "postCoInvestigatorFind",
  GET_CO_INVESTIGATORS = "getCoInvestigators",
  POST_SEARCH_BY_EMAIL = "postSearchByEmail",
  POST_IRB_COINVESTIGATOR = "postIrbCoInvestigator",
  POST_FACULTY_APPROVAL = "postFacultyApproval",
  POST_FACULTY_APPROVAL_REASIGN = "postFacultyApprovalReasing",
  POST_FACULTY_MEMBER_APPROVAL = "postFacultyMemberApproval",
  POST_IRB_ASSIGN = "postIrbAssign",
  POST_IRB_REVIEW_NOTE = "postIrbReviewNote",
  POST_IRB_MAKE_DECISION = "postIrbMakeDecision",
  POST_IRB_CHAIR_MAKE_DECISION = "postIrbChairMakeDecision",
  POST_IRB_MAKE_VOTE = "postIrbMakeVote",
  POST_NOTIFICATION_FORM = "postNotificationForm",
  DELETE_IRB_COINVESTIGATOR = "deleteIrbCoInvestigator",
  DELETE_IRB_APPLICATION = "deleteIrbApplication",
  SUBMIT_IRB_APPLICATION = "submitIrbApplication",
  UPDATE_IRB_APPLICATION = "updateIrbApplication",
  POST_IRB_DOCUMENT = "postIrbDocuments",
  GET_IRB_DOCUMENTS = "getIrbDocuments",
  DELETE_IRB_DOCUMENTS = "deleteIrbDocuments",
  GET_USERS = "getUsers",
  GET_PENDING_USERS = "getPendingUsers",
  ADMIN_ASSIGN_ROLE = "adminAssignRole",
  ADMIN_REMOVE_ROLE = "adminRemoveRole",
  ADMIN_APPROVE_USER = "adminApproveUser",
  GET_IRBCHAIR_APPS = "getIrbchairApps",
  GET_APPS_INFORMATION = "getAppsInformation",
  GET_IRBMEMBER_ASSIGNED_APPS = "getIrbMemberAssignedApps",
  GET_IRBMEMBER_STANDARD_APPS = "getIrbMemberStandardApps",
  GET_IRBMEMBERS = "getIrbMembers",
  GET_IRBTRANSACTION_LOG = "getIrbTransactionLog",
  GET_IRBTRANSACTION_LOGS = "getIrbTransactionLogs",
  GET_IRB_REVIEWER = "getIrbReviewer",
  GET_IRB_REVIEW_NOTES = "getIrbReviewNotes",
  GET_IRB_REVIEW_NOTES_TYPE = "getIrbReviewNotesType",
  GET_IRB_REVIEW_NOTE = "getIrbReviewNote",
  GET_IRB_STANDARD_VOTES = "getIrbStandardVotes",
  GET_IRB_STANDARD_VOTE = "getIrbStandardVote",
  GET_IRB_APPROVAL_LETTERS = "getIrbApprovalLetters",
  GET_IRB_APPROVAL_LETTER_PDF = "getIrbApprovalLetterPdf",
  GET_IRB_APP_PDF = "getIrbAppPdf",
  GET_NOTIFICATION_FORMS = "getNotificationForms",
  GET_NOTIFICATION_FORM = "getNotificationForm",
  GET_NOTIFICATION_FORMS_CHAIR = "getNotificationFormsChair",
  GET_NOTIFICATION_FORMS_MEMBER = "getNotificationFormsMember",
  GET_NOTIFICATION_FORMS_AVAILABLE = "getNotificationFormsAvailable",
  GET_IRBCHAIR_APPS_EXPEDITED = "GET_IRBCHAIR_APPS_EXPEDITED",
}

enum Mutations {
  // mutation types
  SET_CLASSNAME_BY_POSITION = "appendBreadcrumb",
  PURGE_AUTH = "logOut",
  SET_AUTH = "setAuth",
  SET_USER = "setUser",
  SET_PASSWORD = "setPassword",
  SET_ERROR = "setError",
  SET_BREADCRUMB_MUTATION = "setBreadcrumbMutation",
  SET_LAYOUT_CONFIG = "setLayoutConfig",
  RESET_LAYOUT_CONFIG = "resetLayoutConfig",
  OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig",
  OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig",
  SET_IRB_APPLICATIONS = "setIrbApplications",
  SET_IRB_ISSUE = "setIrbIssue",
  SET_IRB_ISSUES = "setIrbIssues",
  SET_IRB_SUSCRIBE_NOTIFICATION_ALERT = "setIrbSuscriptionNotificationAlert",
  SET_IRB_NOTIFICATION_ALERT = "setIrbNotificationAlert",
  SET_IRB_NOTIFICATION_ALERT_PENDING = "setIrbNotificationAlertPending",
  SET_IRB_APP_TITLE = "setIrbAppTitle",
  SET_SUBMITTED_IRB_APPLICATIONS = "setSubmittedIrbApplications",
  SET_IRB_GPT_INFO = "setIrbGptInfo",
  SET_COLLABORATIVE_IRB_APPLICATIONS = "setCollaborativeIrbApplications",
  SET_IRB_DASHBOARD_APPLICATION = "setDashboardApplication",
  SET_IRB_APPLICATION = "setIrbApplication",
  SET_IRB_APPLICATION_FACULTY = "setIrbApplicationFaculty",
  SET_IRB_NON_STANDARD = "setIrbNonStandard",
  SET_IRB_APPLICATION_RESEARCH = "setIrbApplicationResearch",
  SET_IRB_APPLICATION_SUBJECT = "setIrbApplicationSubject",
  SET_IRB_APPLICATION_RISK = "setIrbApplicationRisk",
  SET_IRB_APPLICATION_RECRUITMENT = "setIrbApplicationRecruitment",
  SET_IRB_APPLICATION_INFORMED = "setIrbApplicationInformed",
  SET_IRB_APPLICATION_DATA = "setIrbApplicationData",
  SET_IRB_SCREENING = "setIrbScreening",
  SET_FACULTY_SPONSORS = "setFacultySponsors",
  SET_FACULTY_MEMBER = "setFacultyMember",
  SET_IRB_ERROR = "setIrbError",
  SET_APPS_INFORMATION = "setAppsInformation",
  SET_CO_INVESTIGATOR_FIND = "setCoInvestigatorFind",
  SET_CO_INVESTIGATORS = "setCoInvestigators",
  SET_SEARCH_BY_EMAIL = "setSearchByEmail",
  SET_IRB_COINVESTIGATOR = "setIrbCoInvestigator",
  SET_IRB_COINVESTIGATOR_EDIT = "setIrbCoInvestigatorEdit",
  SET_IRB_DOCUMENT_DATA = "setIrbDocumentData",
  SET_IRB_DOCUMENTS = "setIrbDocuments",
  SET_USERS = "setUsers",
  SET_PENDING_USERS = "setPendingUsers",
  SET_ADMIN_USER_EDIT = "setAdminUserEdit",
  SET_ADMIN_MESSAGE = "setAdminMessage",
  SET_FACULTY_SPONSOR_REQUESTS = "setFacultySponsorRequests",
  SET_FACULTY_SPONSOR_REQUEST_EDIT = "setFacultySponsorRequestEdit",
  SET_FACULTY_MEMBER_REQUESTS = "setFacultyMemberRequests",
  SET_FACULTY_MEMBER_REQUEST_EDIT = "setFacultyMemberRequestEdit",
  SET_FACULTY_MESSAGE = "setFacultyMessage",
  SET_FACULTY_MEMBER_MESSAGE = "setFacultyMemberMessage",
  SET_IRBCHAIR_APPS = "setIrbchairApps",
  SET_IRBMEMBER_ASSIGNED_APPS = "setIrbMemberAssignedApps",
  SET_NOTIFICATION_FORM_MESSAGE = "setNotificationFormMessage",
  SET_NOTIFICATION_FORM_EDIT = "setNotificationFormEdit",
  SET_NOTIFICATION_FORM_REQUESTS = "setNotificationFormRequest",
  SET_IRBMEMBER_STANDARD_APPS = "setIrbMemberStandardApps",
  SET_IRBMEMBERS = "setIrbMembers",
  SET_IRBTRANSACTION_LOG = "setIrbTransactionLog",
  SET_IRBTRANSACTION_LOGS = "setIrbTransactionLogs",
  SET_IRBCHAIR_APP = "setIrbchairApp",
  SET_IRB_APP_EDIT = "setIrbAppEdit",
  SET_IRB_APP = "setIrbApp",
  SET_IRB_REVIEWER = "setIrbReviewer",
  SET_IRB_REVIEW_NOTE = "setIrbReviewNote",
  SET_IRB_REVIEW_NOTES = "setIrbReviewNotes",
  SET_IRB_REVIEW_NOTES_TYPE = "setIrbReviewNotesType",
  SET_IRB_REVIEW_NOTE_EDIT = "setIrbReviewNoteEdit",
  SET_IRB_STANDARD_VOTE = "setIrbStandardVote",
  SET_IRB_STANDARD_VOTES = "setIrbStandardVotes",
  SET_IRB_APPROVAL_LETTERS = "setIrbApprovalLetters",
}

export { Actions, Mutations };
